import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import UpcomingDatesInfo from './UpcomingDatesInfo';
import { T } from '../../../../../../../../Translations';
import { ExperienceDetailResource } from '../../../../../CurrentCollectionStep/BuilderV2/Types';

interface Props {
  experienceDetailResource: ExperienceDetailResource;
}

function ExperienceUpcomingDates({ experienceDetailResource }: Props) {
  return fromArrayMaybe(experienceDetailResource.payload.start_dates)
    .map((startDates) => {
      return (
        <div className="flex flex-col gap-y-4">
          <Typography className="tracking-[0.2px]" variant="caption" fontWeight="medium">
            <T kind="Upcoming Start Date" />
          </Typography>
          {startDates.map((startDate) => (
            <UpcomingDatesInfo key={startDate.start_on} startOn={startDate.start_on} />
          ))}
        </div>
      );
    })
    .getOrElse(emptyFragment);
}

export default observer(ExperienceUpcomingDates);
